"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateQueryParameterArrayToString = exports.handleError = exports.getSystemErrorResponse = exports.getErrorMessages = exports.SERVER_ERROR_MESSAGE = exports.isAxiosError = void 0;
var axios_1 = __importDefault(require("axios"));
var baseURL = "";
var isAxiosError = function (error) {
    return !!error.isAxiosError;
};
exports.isAxiosError = isAxiosError;
exports.SERVER_ERROR_MESSAGE = "原因不明のエラーが発生しました。";
var getErrorMessages = function (error) {
    if (typeof error === "undefined") {
        return [];
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- 暫定対応
    return error.errors;
};
exports.getErrorMessages = getErrorMessages;
var getSystemErrorResponse = function () {
    return {
        status: 500,
        errors: ["システムエラー"],
    };
};
exports.getSystemErrorResponse = getSystemErrorResponse;
var handleError = function (response, enqueueSnackbar) {
    if (response.status === 500) {
        enqueueSnackbar(exports.SERVER_ERROR_MESSAGE, {
            variant: "error",
        });
        return;
    }
    var errorMessages = (0, exports.getErrorMessages)(response);
    errorMessages.forEach(function (error) {
        enqueueSnackbar(error, { variant: "error" });
    });
    return;
};
exports.handleError = handleError;
var instance = axios_1.default.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },
    withCredentials: true,
    responseType: "json",
});
// eslint-disable-next-line import/no-default-export -- 暫定対応
exports.default = instance;
var generateQueryParameterArrayToString = function (key, values) {
    return values
        .map(function (value, index) {
        if (typeof value === "boolean") {
            return "".concat(key, "[").concat(index, "]=").concat(value ? "1" : "0");
        }
        else {
            return "".concat(key, "[").concat(index, "]=").concat(value);
        }
    })
        .join("&");
};
exports.generateQueryParameterArrayToString = generateQueryParameterArrayToString;
